import "./App.css";
import { RouterProvider } from "react-router-dom";
import router from "./router/routes";
import { ThemeProvider } from "./context/ThemeContext";
import "./i18n/i18n";

const App = () => {
  return (
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  );
};

export default App;
